module.exports = __webpack_public_path__ + "img/products_big_can_original2.707d85ad.png";